<template>
  <div class="title">{{ title }} {{ desc }}</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Title extends Vue {
  @Prop({}) title!: string;
  @Prop({}) desc!: string;
}
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 24px;
  color: #382d68;
  font-weight: bold;
  font-size: 30px;
  line-height: 42px;
  text-align: center;
}
</style>
